var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import BackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { DataContainerNew } from '../../components/atoms/DataContainer';
import { getRoleString } from '../../types';
import { useQuery } from '../../hooks';
import { Delimiter } from '../../components/atoms/Delimiter';
import { getMatchLeaders } from '../../api';
import { Loader } from '../../components/atoms/Loader/Loader';
import { Logo } from '../../components/organisms/Logo/Logo';
// const commonStyles = {
//   bgcolor: 'background.paper',
//   borderColor: 'text.primary',
//   border: 1,
//   wrap: 'nowrap',
//   display: 'flex',
//   flexDirection: 'column',
//   padding: '26px 26px 0',
//   borderRadius: '8px',
//   width: '683px',
// }
// const PageWrapper = styled(PageWrapperNew)`
//   width: 683px;
//   background: radial-gradient(100.48% 122.16% at 99.03% 98.33%, #356166 14.37%, #2e4245 82.78%);
//   box-shadow: 0px 0px 17px rgb(83 189 211 / 55%), inset 0px 0px 10px #bdf4ff;
//   border-radius: 24px;
//   padding: 26px 26px 0;
// `
const PageContainer = styled(DataContainerNew) `
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;
// const FlexContainer = styled.div`
//   display: flex;
// `
const ButtonsContainer = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
// const MatchInfoText = styled.div`
//   font-size: 16px;
//   line-height: 28px;
//   color: rgba(0, 0, 0, 0.7);
//   span {
//     font-size: 14px;
//     line-height: 20px;
//   }
// `
const PageTitle = styled.div `
  font-weight: 500;
  font-size: 36px;
  line-height: 38px;
  color: #000;
`;
const NoLeadersTitle = styled(PageTitle) `
  text-align: center;
`;
// const SymbolsWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   width: 100%;
// `
const SymbolIcon = styled.div `
  width: 19px;
  height: 19px;
  border-radius: 50%;

  ${({ color }) => color === 'green'
    ? `
    border: 1px solid #ffffff;
    filter: drop-shadow(0px 0px 1px #66FB4D) drop-shadow(0px 0px 2px #66FB4D) drop-shadow(0px 0px 4px #66FB4D)drop-shadow(0px 0px 6px #66FB4D);
  `
    : `
    border: 1px solid #ffffff;
    filter: drop-shadow(0px 0px 1px #FD7D6B) drop-shadow(0px 0px 2px #FD7D6B) drop-shadow(0px 0px 4px #FD7D6B)drop-shadow(0px 0px 6px #FD7D6B);
  `}
`;
// const SymbolDesc = styled.div`
//   font-size: 14px;
//   line-height: 20px;
//   color: #000;
//   margin-left: 8px;
// `
// const SymbolsTitle = styled.div`
//   font-weight: 500;
//   font-size: 14px;
//   line-height: 20px;
//   color: #000;
//   margin-right: 18px;
// `
// const HeaderImage = styled.img<{ color?: string }>`
//   width: 74px;
//   height: 72px;
//   display: block;
//   transition: 0.4s;
//   ${({ color }) =>
//     color === 'red'
//       ? `filter: drop-shadow(0px 0px 15px rgba(253, 125, 107, 0.3)) drop-shadow(0px 0px 2px #FD7D6B) drop-shadow(0px 0px 2px #FD7D6B);`
//       : `filter: drop-shadow(0px 0px 15px rgba(148, 234, 62, 0.3)) drop-shadow(0px 0px 2px #94ea3e) drop-shadow(0px 0px 2px #94ea3e);`}
// `
const LeadersWrapper = styled.div `
  display: flex;
  width: calc(100% - 20px);
  justify-content: space-between;
  align-self: center;
`;
const LeaderContainer = styled.div `
  position: relative;
  width: 181px;
  min-height: 277px;
  order: ${({ order }) => order};
  align-self: flex-end;

  &:first-child {
    align-self: flex-start;
    margin-bottom: 15px;
  }
`;
const LeaderInfoWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 4px 4px 10px;
  background: #272724;
  border-radius: 23px;

  box-shadow: ${({ color }) => `0px 0px 12px ${color}, 0px 0px 12px ${color}, 0px 0px 12px ${color}, 0px 0px 6px ${color}, 0px 0px 8px ${color}, 0px 0px 8px ${color}`};
`;
const LeaderImg = styled.img `
  width: 173px;
  height: 201px;
  display: block;
  border-radius: 20px;
  user-select: none;
  object-fit: cover;
  background: #d9d9d9;
  border: 2px solid ${({ color }) => color};
`;
const LeaderNick = styled.div `
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
`;
const LeaderName = styled.div `
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  text-align: center;
`;
const LeaderGamesContainer = styled.div `
  display: flex;
  max-width: 52px;
  flex-wrap: wrap;
  align-self: flex-end;
  margin-right: 16px;
`;
const LeaderGames = styled(SymbolIcon) `
  margin: 2px;
  width: 9px;
  height: 9px;
`;
const LeaderRating = styled.div `
  position: relative;
  left: 6px;
  bottom: 15px;
  width: 85px;
  height: 30px;
  background: #272724;
  border-radius: 7px;
  box-shadow: ${({ color }) => `0px 0px 12px ${color}, 0px 0px 12px ${color}, 0px 0px 12px ${color}, 0px 0px 6px ${color}, 0px 0px 8px ${color}`};
  font-weight: 700;
  font-size: 12px;
  line-height: 30px;
  color: ${({ color }) => color};
  text-align: center;
`;
export function MatchLeaders() {
    const { param: eventId } = useQuery('eventId');
    const nav = useNavigate();
    const [leaders, setLeaders] = useState([]);
    const [loading, setLoading] = useState(false);
    const getLeaders = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (!eventId)
            return;
        try {
            setLoading(true);
            const result = yield getMatchLeaders(eventId);
            console.log('MatchLeaders getLeaders', result);
            if (!((_a = result === null || result === void 0 ? void 0 : result.leaders) === null || _a === void 0 ? void 0 : _a.first)) {
                setLoading(false);
                return;
            }
            const values = Object.values(result.leaders);
            setLeaders(values);
            setLoading(false);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('MatchLeaders getLeaders error', e);
        }
    }), [eventId]);
    useEffect(() => {
        getLeaders();
    }, [eventId, getLeaders]);
    const onClickBack = () => {
        nav(`/matches?eventId=${eventId}`);
    };
    return (_jsxs(PageContainer, { children: [_jsx(ButtonsContainer, { children: _jsx(Button, Object.assign({ onClick: () => onClickBack(), startIcon: _jsx(BackIcon, {}) }, { children: "\u041A \u0430\u0444\u0438\u0448\u0435" })) }), _jsx(Logo, {}), _jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u041B\u0443\u0447\u0448\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0438 \u0432\u0435\u0447\u0435\u0440\u0430" })), _jsx(Delimiter, { top: "20px" }), _jsx(Delimiter, { top: "20px" }), loading && _jsx(Loader, {}), !loading && !!leaders.length && (_jsx(TableContainer, Object.assign({ sx: { width: 708 }, component: Paper }, { children: _jsxs(Table, Object.assign({ "aria-label": "customized table" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u0433\u0440\u043E\u0432\u043E\u0435 \u0438\u043C\u044F" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0420\u0435\u0439\u0442\u0438\u043D\u0433" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u041B\u0443\u0447\u0448\u0430\u044F \u0438\u0433\u0440\u0430" }))] }) }), _jsx(TableBody, { children: leaders.map((leader) => {
                                var _a, _b, _c;
                                return (_jsxs(TableRow, { children: [_jsxs(TableCell, Object.assign({ variant: "body", align: "center" }, { children: [(_a = leader === null || leader === void 0 ? void 0 : leader.player) === null || _a === void 0 ? void 0 : _a.gameName, "(", (_c = (_b = leader === null || leader === void 0 ? void 0 : leader.player) === null || _b === void 0 ? void 0 : _b.realName) === null || _c === void 0 ? void 0 : _c.trim(), ")"] })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: leader === null || leader === void 0 ? void 0 : leader.totalRating })), _jsxs(TableCell, Object.assign({ variant: "body", align: "center" }, { children: [getRoleString(leader === null || leader === void 0 ? void 0 : leader.bestMatch.role), " (", leader === null || leader === void 0 ? void 0 : leader.bestMatch.rating, " \u043E\u0447\u043A\u043E\u0432)"] }))] }, leader === null || leader === void 0 ? void 0 : leader.player.id));
                            }) })] })) }))), !loading && !leaders.length && _jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0418\u0433\u0440\u043E\u043A\u043E\u0432 \u0432\u0435\u0447\u0435\u0440\u0430 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442" }))] }));
}
